const values = {
  TEACHER_TYPE: {
    teacher: 'TEACHER',
    promotionTeacher: 'PROMOTION_TEACHER',
  },
  CONTENTS: {
    TEACHER: {
      title: '윙크 선생님 모집',
      imgCount: 4,
      prefix:
        'https://s.wink.co.kr/pc/renewalV3/service_center/recruit/content',
      modifiedInfoList: [
        {
          modifiedDate: '231025',
          modifiedIndexList: [2],
        },
      ],
      backgroundColors: ['#00a0df', '#f1f1f2', '#ef3a7a', '#f1f1f2'],
      buttonIndex: [3],
      button:
        'https://s.wink.co.kr/pc/renewalV3/service_center/recruit/apply.png',
      link: 'https://bit.ly/2VGocMf',
      buttonStyle: {
        width: 517,
      },
    },
    PROMOTION_TEACHER: {
      title: '홍보 선생님 모집',
      imgCount: 3,
      prefix:
        'https://s.wink.co.kr/marketing/homepage/promotionTeacher/PC/content',
      modifiedInfoList: [],
      backgroundColors: ['#C2F3A9', '#FEFBFB', '#FEFBFB'],
      button:
        'https://s.wink.co.kr/marketing/homepage/promotionTeacher/PC/btn/btn_1.png',
      link: 'http://www.fashionbiz.co.kr/TN/?cate=2&recom=2&idx=199200',
      buttonIndex: [1],
      recruitButton:
        'https://s.wink.co.kr/marketing/homepage/promotionTeacher/PC/btn/btn_2.png',
      recruitLink: 'https://danbiedu.career.greetinghr.com/o/57077 ',
    },
  },
};

export default values;
